import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";

export const recoveryPlanCols = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({ viewModal, updateModal, deleteRecord });

  return {
    "Insurance Claim Procedures": [
      { title: "Policy", dataIndex: "Policy", key: "policy" },
      { title: "Policy Procedure", dataIndex: "Policy Procedure", key: "policyprocedure" },
    ],
    "Contractor Contacts": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
      {
        title: "Specialty",
        dataIndex: "Specialty",
        key: "specialty",
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
      },
      actionColumn,
    ],
    "Restoration Services": [
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phone number",
      },
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
      },
      {
        title: "Specialty",
        dataIndex: "Specially",
        key: "specialty",
      },
      actionColumn,
    ],
  };
};
